import { DecimalPipe, UpperCasePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  OnyxIconComponent,
  OnyxLanguagePipe,
  OnyxPhonePipe,
} from '@onyx/angular';
import { ParametersCellComponent } from '../../../../../../../../../common/components/cells/parameters-cell/parameters-cell.component';
import { DictionaryCode } from '../../../../../../../../../common/enums/dictionary-code';
import { FleetIdentifierPipe } from '../../../../../../../../../common/pipes/fleet-identifier.pipe';
import { GoodQuantityPipe } from '../../../../../../../../../common/pipes/good-quantity.pipe';
import { JoinPipe } from '../../../../../../../../../common/pipes/join.pipe';
import { OrderPointCategory } from '../../../../../../../common/enums/order-point-category';
import type { Order } from '../../../../../../../common/interfaces/order';
import type { OrderLoadingPoint } from '../../../../../../../common/interfaces/order-point';

@Component({
  selector: 'app-order-pdf-template-details',
  imports: [
    OnyxIconComponent,
    TranslatePipe,
    UpperCasePipe,
    ParametersCellComponent,
    DecimalPipe,
    JoinPipe,
    FleetIdentifierPipe,
    OnyxPhonePipe,
    OnyxLanguagePipe,
    GoodQuantityPipe,
  ],
  templateUrl: './order-pdf-template-details.component.html',
  styleUrl: './order-pdf-template-details.component.scss',
})
export class OrderPdfTemplateDetailsComponent {
  public readonly order = input.required<Order>();

  protected readonly DictionaryCode = DictionaryCode;

  protected loadingPoints = computed<OrderLoadingPoint[]>(() =>
    this.order().points.filter(
      (point) => point.category === OrderPointCategory.LOADING,
    ),
  );
  protected loadingGoods = computed(() =>
    this.loadingPoints().flatMap((item) => item.goods),
  );
}
